import {IUserService} from '../../../services/user';
import {ITrackingService} from '../../../services/gtmHelper';
import {HtmlHelper} from '../../../services/htmlHelper';
import {PurchasePage} from '../purchasePage';
import {AuthService} from '../../../services/authService';
import {ITranslateService} from '../../../services/translateService';
import {EnvConfig} from '../../../config/envConfig.interface';
import {ISessionService} from '../../../services/session';
import {IPurchaseService} from '../../../services/purchase';
import {IBindingService} from '../../../services/bindingService';
import {ILoginFlowFactory} from './loginFlowFactory';

export class LoginPage extends PurchasePage {
  constructor(
    protected configuration: EnvConfig,
    protected authService: AuthService,
    protected translateService: ITranslateService,
    protected sessionService: ISessionService,
    protected userService: IUserService,
    protected trackingService: ITrackingService,
    protected purchaseService: IPurchaseService,
    protected bindingService: IBindingService,
    protected loginFlowFactory: ILoginFlowFactory,
  ) {
    super(
      configuration,
      authService,
      translateService,
      sessionService,
      userService,
      trackingService,
      purchaseService,
      bindingService,
    );
  }
  public render(): void {
    const loginFlow = this.loginFlowFactory.getLoginFlow();
    // warning: we have to use promise chain here, because
    // `render` method doesn't allow async/await
    void loginFlow
      .initialize({
        container: this.getContainer(),
      })
      .then(() => {
        loginFlow.onLoginFlowStatusChange(async ({loginFlowStatus}) => {
          if (loginFlowStatus === 'finish') {
            await loginFlow.finishLoginFlow();
          } else {
            await loginFlow.startLoginFlow();
          }
        });
      });

    const signoutButton = this.getSignoutButton();

    signoutButton.addEventListener('click', async () => {
      await loginFlow.signOut();
    });
  }

  private getContainer(): HTMLElement {
    return document.getElementsByClassName(
      'sc-purchase-login',
    )[0] as HTMLElement;
  }

  private getSignoutButton(): HTMLElement {
    const button = HtmlHelper.instance.document.getElementById('btn-logout');

    if (!button) {
      console.error('signout button (#btn-logout) not found on the page.');
      throw new Error('signout button not found on the page');
    }

    return button;
  }
}
